<div>
    <div mat-dialog-content>
        <button class="close_btn" (click)="close()"></button>
        <iframe
            src="https://tesla.virtualtour.poppr.be/"
            name="tesla-tour"
            scrolling="no"
            style="border: none; width: 100vw; height: 100vh; aspect-ratio: 2 / 1"
        ></iframe>
    </div>
</div>
